import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const MajorCreateCategory = async (payload) => {
  try {
    const response = await APIs.post('/create_major_categroy', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorCategory = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_major_category/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorMajorCategory = async () => {
  try {
    const response = await APIs.get(`/get_all_major_major_category`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadMajorCategoryImage = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadMajorCategoryIcon = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteMajorCategory = async (payload) => {
  try {
    const response = await APIs.post(`/delete_major_category`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleMajorCategoryDetails = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_single_major_category/${payload?.Id}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForMajorCategoryByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_major_category_by_name/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const MajorCategoryServices = {
  MajorCreateCategory,
  getAllMajorCategory,
  getAllMajorMajorCategory,
  uploadMajorCategoryImage,
  uploadMajorCategoryIcon,
  DeleteMajorCategory,
  getSingleMajorCategoryDetails,
  SearchForMajorCategoryByName,
};

export default MajorCategoryServices;
